


import Vue from 'vue'
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  beforeCreate() {
    // @ts-ignore
    this.$fontTransform.run(this.$i18n.vm.messages)
  },
  render() {
    return (
      <div class="label" style={this.$t('28PingFangHK400.style')}>
        {this.label}
      </div>
    )
  }
})
